import CXCountryData from '@sanlamcx/react-ui-next-country-data';

export const CountryData = CXCountryData;
